export const HH_LOCALE_COOKIE_NAME = "__hh_preferred_locale";

export enum SUPPORTED_LOCALE {
  EN_US = "en-US",
  ES_US = "es-US",
  FR_CA = "fr-CA",
  FR_FR = "fr-FR",
  DE_DE = "de-DE",
  NL_NL = "nl-NL",
  EN_GB = "en-GB",
  HI_IN = "hi-IN",
  ES_MX = "es-MX",
}

export const ALL_SUPPORTED_LOCALES = Object.values(SUPPORTED_LOCALE);

export const languageToLocaleMap: Record<string, SUPPORTED_LOCALE> = {
  en: SUPPORTED_LOCALE.EN_US,
  es: SUPPORTED_LOCALE.ES_US,
  "fr-CA": SUPPORTED_LOCALE.FR_CA,
  fr: SUPPORTED_LOCALE.FR_FR,
  de: SUPPORTED_LOCALE.DE_DE,
  nl: SUPPORTED_LOCALE.NL_NL,
  "en-GB": SUPPORTED_LOCALE.EN_GB,
};

export interface LocaleConfig {
  country: string;
  locale: string;
  pathPrefix: string;
  redirectPathPrefix?: string;
}

export const localeMappings: LocaleConfig[] = [
  // US
  {
    country: "us",
    locale: SUPPORTED_LOCALE.EN_US,
    pathPrefix: "",
    redirectPathPrefix: "/",
  },
  { country: "us", locale: SUPPORTED_LOCALE.ES_US, pathPrefix: "/us/es/" },

  // CA
  { country: "ca", locale: SUPPORTED_LOCALE.EN_US, pathPrefix: "/ca/en/" },
  { country: "ca", locale: SUPPORTED_LOCALE.FR_CA, pathPrefix: "/ca/fr/" },

  // United Kingdom
  { country: "gb", locale: SUPPORTED_LOCALE.EN_GB, pathPrefix: "/gb/en/" },

  // Ireland
  { country: "ie", locale: SUPPORTED_LOCALE.EN_GB, pathPrefix: "/ie/en/" },

  // France
  { country: "fr", locale: SUPPORTED_LOCALE.EN_GB, pathPrefix: "/fr/en/" },
  { country: "fr", locale: SUPPORTED_LOCALE.FR_FR, pathPrefix: "/fr/fr/" },

  // Netherlands
  { country: "nl", locale: SUPPORTED_LOCALE.EN_GB, pathPrefix: "/nl/en/" },
  { country: "nl", locale: SUPPORTED_LOCALE.NL_NL, pathPrefix: "/nl/nl/" },

  // Germany
  { country: "de", locale: SUPPORTED_LOCALE.EN_GB, pathPrefix: "/de/en/" },
  { country: "de", locale: SUPPORTED_LOCALE.DE_DE, pathPrefix: "/de/de/" },
];

export const defaultLocale: SUPPORTED_LOCALE = SUPPORTED_LOCALE.EN_US;

export type LocaleItem = {
  value: SUPPORTED_LOCALE;
  label: string;
};

export const languages = [
  { label: "English (United States)", value: SUPPORTED_LOCALE.EN_US },
  { label: "English (United Kingdom)", value: SUPPORTED_LOCALE.EN_GB },
  { label: "Français (Canada)", value: SUPPORTED_LOCALE.FR_CA },
  { label: "Français (France)", value: SUPPORTED_LOCALE.FR_FR },
  { label: "Deutsch", value: SUPPORTED_LOCALE.DE_DE },
  { label: "Español", value: SUPPORTED_LOCALE.ES_US },
  { label: "Nederlands", value: SUPPORTED_LOCALE.NL_NL },
];

export enum Region {
  US = "us",
  INT = "int",
}

enum Country {
  US = "country.us",
  INT = "country.international",
}

export const regionSelection = [
  { id: Region.US, title: Country.US },
  { id: Region.INT, title: Country.INT },
];
